import script from "./MeetCallRoomStudio.vue?vue&type=script&setup=true&lang=js"
export * from "./MeetCallRoomStudio.vue?vue&type=script&setup=true&lang=js"

import "./MeetCallRoomStudio.vue?vue&type=style&index=0&id=4dc1a3d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dc1a3d6"]])

export default __exports__